export default __webpack_public_path__ + "assembly541b191.png";